import { render, staticRenderFns } from "./SplashAnimation.vue?vue&type=template&id=22a8c983&scoped=true&"
var script = {}
import style0 from "./SplashAnimation.vue?vue&type=style&index=0&id=22a8c983&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a8c983",
  null
  
)

export default component.exports